import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { PlanUserInfo } from '../plan-user-info.model';
import { PlanUserInfoActions, PlanUserInfoActionTypes } from '../actions/plan-user-info.actions';

export interface State extends EntityState<PlanUserInfo> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<PlanUserInfo> = createEntityAdapter<PlanUserInfo>({
  selectId: data => data.acode
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(
  state = initialState,
  action: PlanUserInfoActions
): State {
  switch (action.type) {
    case PlanUserInfoActionTypes.AddPlanUserInfo: {
      return adapter.addOne(action.payload.planUserInfo, state);
    }

    case PlanUserInfoActionTypes.UpsertPlanUserInfo: {
      return adapter.upsertOne(action.payload.planUserInfo, {...state, Loaded: true, Loading: false});
    }

    case PlanUserInfoActionTypes.AddPlanUserInfos: {
      return adapter.addMany(action.payload.planUserInfos, state);
    }

    case PlanUserInfoActionTypes.UpsertPlanUserInfos: {
      return adapter.upsertMany(action.payload.planUserInfos, state);
    }

    case PlanUserInfoActionTypes.UpdatePlanUserInfo: {
      return adapter.updateOne(action.payload.planUserInfo, state);
    }

    case PlanUserInfoActionTypes.UpdatePlanUserInfos: {
      return adapter.updateMany(action.payload.planUserInfos, state);
    }

    case PlanUserInfoActionTypes.DeletePlanUserInfo: {
      return adapter.removeOne(action.payload.id, state);
    }

    case PlanUserInfoActionTypes.DeletePlanUserInfos: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case PlanUserInfoActionTypes.LoadPlanUserInfos: {
      return adapter.setAll(action.payload.planUserInfos, state);
    }

    case PlanUserInfoActionTypes.ClearPlanUserInfos: {
      return adapter.removeAll(state);
    }

    case PlanUserInfoActionTypes.GetPlanUserInfos: {
      return {...state, Loaded: false, Loading: true};
    }

    case PlanUserInfoActionTypes.GetPlanUserInfosFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
